import { render, staticRenderFns } from "./DownloadPlugin.vue?vue&type=template&id=006ce519&scoped=true"
import script from "./DownloadPlugin.vue?vue&type=script&lang=js"
export * from "./DownloadPlugin.vue?vue&type=script&lang=js"
import style0 from "./DownloadPlugin.vue?vue&type=style&index=0&id=006ce519&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "006ce519",
  null
  
)

export default component.exports